// フロントエンドのみで利用しているenumの格納ファイル
// 機能にまたがって使用する場合、ここに記載してください

export const e記号 = {
  黒丸: "●",
  丸: "〇",
  黒三角: "▲",
  三角: "△",
  星: "☆",
  黒星: "★",
  下三角: "▽",
} as const

export type T記号名称 = keyof typeof e記号
export type T記号 = typeof e記号[T記号名称]

export const e検索日種別 = {
  積日: "1",
  卸日: "2",
  請求計上日: "3",
} as const

export type T検索日種別プロパティ名称 = keyof typeof e検索日種別
export type T検索日種別コード = typeof e検索日種別[T検索日種別プロパティ名称]

export const e海コン検索日種別 = {
  PICK作業日: "1",
  作業作業日: "2",
  返却作業日: "3",
  その他作業日: "4",
  請求計上日: "5",
  PICK作業返却その他: "6",
} as const

export type T海コン検索日種別種別プロパティ名称 = keyof typeof e海コン検索日種別
export type T海コン検索日種別コード =
  typeof e海コン検索日種別[T海コン検索日種別種別プロパティ名称]

//乗務員給与一覧は1：乗務員を設定　事務員就労時間一覧は2：事務員設定
export const eレコード種別 = {
  乗務員給与一覧: "1",
  事務員就労時間一覧: "2",
} as const

export type Tレコード種別プロパティ名称 = keyof typeof eレコード種別
export type Tレコード種別種別コード =
  typeof eレコード種別[Tレコード種別プロパティ名称]

export const e主要荷主 = {
  荷主数: 10,
} as const

export type T主要荷主名称 = keyof typeof e主要荷主
export type T主要荷主コード = typeof e主要荷主[T主要荷主名称]
